// export default AccountFilter
import React, { useContext, useState, useRef, useEffect } from 'react'
import InputSelect from '../../Custom/CustomInput/InputSelect'
import { removeSpecialCharacters, removeWhiteSpace } from '../../Utility/Utility.js'
import SearchFieldsContext from '../context/context'
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined'
import { fetchAccountSuggestion } from '../../Services/propertySearchService'
// import { AuthContext } from '../../../../context/AuthContext'

const AccountFilter = () => {
    // const SearchFields = useContext(SearchFieldsContext)
    const { searchFields, setSearchFields, searchCriteria, setSearchCriteria } = useContext(SearchFieldsContext)
    const [accountSuggestions, setAccountSuggestions] = useState([])
    const [showSuggestionSpinner, setShowSuggestionSpinner] = useState(false)
    const [show, setShow] = useState(false)
    // const inputVal = useRef(null)
    const [inputVal, setInputVal] = useState('')

    // const keycloak = useContext(AuthContext)

    useEffect(
        () => {
            if (inputVal.length >= 2) {
                inputChanged()
            }
        },
        [inputVal]
    )

    function handleSelectChange(e) {
        let { value } = e.target
        const newSearchFields = searchFields
        newSearchFields.accountFields[1] = { ...newSearchFields.accountFields[1], value: value }
        setSearchFields({ ...newSearchFields })
    }

    function handleChange(e) {
        let { value } = e.target

        setInputVal(value)

        if (value.length < 3) {
            setAccountSuggestions([])
        }
    }

    function inputChanged() {

        let suggestionCriteria = {}
        let payLoad = ''
        let newInputVal = inputVal
        // const i = searchFields.accountFields.findIndex(x => x.fieldName === e.target.getAttribute('data-propid'))

        newInputVal = removeSpecialCharacters(newInputVal)
        newInputVal = removeWhiteSpace(newInputVal)

        if (newInputVal.length >= 2) {

            setShow(true)

            if (newInputVal.length > 3) {
                setShowSuggestionSpinner(true)
            }

            suggestionCriteria = {
                name: newInputVal
            }

            payLoad = JSON.stringify({
                suggestion: suggestionCriteria
            })

            fetchSuggestion(payLoad)
        }
    }

    function isShowSuggestions(onFocus) {
        let newShow = false
        if (accountSuggestions.length > 0 && onFocus) {
            newShow = true
        }

        setShow(newShow)
    }

    // const accountData = { "total": 34, "data": [{ "omniViewAccountId": "5xVir", "name": "512 Realty" }, { "omniViewAccountId": "1c6cDe", "name": "Sierra Realty & Management" }, { "omniViewAccountId": "gyrGSA", "name": "Saroay Investment Realty" }, { "omniViewAccountId": "gyVQs", "name": "Intrepid Realty" }, { "omniViewAccountId": "e7FOw", "name": "Westlake Realty" }, { "omniViewAccountId": "1gynWc", "name": "Standard Home Realty" }, { "omniViewAccountId": "1BVWNF", "name": "Carriage House Realty" }, { "omniViewAccountId": "5wOP3", "name": "Diamond Realty Investments, Inc." }, { "omniViewAccountId": "1BVX72", "name": "Cohen Realty Group, LLC" }, { "omniViewAccountId": "1mVKUM", "name": "LBJ Realty" }], "aggsData": null, "afterKey": null }

    const fetchSuggestion = async payLoad => {
        const response = await fetchAccountSuggestion(payLoad)
        setShowSuggestionSpinner(false)
        // console.log('fetchSuggestion::', response)

        if (response && response.status === 200) {
            if (response.data && response.data.data) {
                setAccountSuggestions(response.data.data)
                isShowSuggestions(true)
                setShow(true)
            }
        }
    }

    const clearSelectedAccount = () => {
        const newSearchFields = { ...searchFields }
        newSearchFields.accountFields[0].accountName = ''
        newSearchFields.accountFields[0].accountId = ''
        setSearchFields({ ...newSearchFields })

        const newSearchCriteria = { ...searchCriteria }
        newSearchCriteria.accountFields = []
        setSearchCriteria({ ...newSearchCriteria })
    }

    function isShowSuggestions(onFocus) {
        let newShow = false
        if (accountSuggestions.length > 0 && onFocus) {
            newShow = true
        }

        setShow(newShow)
    }

    const handleClick = account => {
        setShow(false)
        setAccountSuggestions([])

        const newSearchFields = { ...searchFields }
        newSearchFields.accountFields[0].accountName = account.accountName
        newSearchFields.accountFields[0].accountId = account.omniViewAccountId
        setSearchFields({ ...newSearchFields })
    }

    function highlightText(inputString) {
        let textToHighlight = inputVal
        textToHighlight = removeWhiteSpace(textToHighlight)

        inputString = inputString.toLowerCase()
        let splitInput = inputString.split(textToHighlight)

        return (
            <>
                <span className="capitalize">
                    {splitInput.map((value, index) => (
                        <>
                            {index + 1 >= splitInput.length ?
                                value
                                : <span>{value}<b>{textToHighlight}</b></span>}
                        </>
                    ))}
                </span>
            </>
        )
    }

    // window.addEventListener('click', e => {
    //     if (document.getElementById('divAccountSuggestion') && !document.getElementById('divAccountSuggestion').contains(e.target)) {
    //         if (show) {
    //             setShow(false)
    //         }
    //     }
    // })

    return (
        <>
            <div className="flex flex-col gap-2">
                {searchFields ?
                    searchFields.accountFields.map(value => {
                        return (
                            value.optionsList ? <>
                                <div className="text-2">
                                    <label>{value.label}</label>
                                </div>
                                <div className="mb-3">
                                    <div className="flex flex-row space-x-2 sm:space-x-4">
                                        <InputSelect testid="test-input-select-transaction" onChange={handleSelectChange} propid={value.fieldName} optionsList={value.optionsList} testid={`Select-${value.fieldName}`} id={value.label.replace(/\s/g, '')} value={value.value} classes={value.isMinMax ? '' : 'w-full'}></InputSelect>
                                    </div>
                                </div>
                            </> :
                                <>
                                    <div className="text-2">
                                        <label>{value.label}</label>
                                    </div>
                                    <div className="mb-3">
                                        <div className="w-full inline-flex items-center border-1 border-base rounded align-middle py-2">
                                            <div className="flex flex-row space-x-2 sm:space-x-4 w-full ">
                                                <div id="divAccountSuggestion" onFocus={()=>setShow(true)} onBlur={()=>setTimeout(()=>setShow(false), 500)} className="relative flex w-full flex-wrap items-stretch w-auto ">
                                                    {!searchFields.accountFields[0].accountName ?
                                                        showSuggestionSpinner ?
                                                            <span className="loader h-6 w-6 items-center justify-center text-center absolute ml-3" ></span>
                                                            :
                                                            <span className="z-10 h-full leading-snug font-normal absolute text-center text-gray-400 absolute bg-transparent rounded text-base items-center justify-center w-7">
                                                                <svg className="w-5 h-5 fill-current text-gray-500 z-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" /></svg>
                                                            </span>
                                                        : null}

                                                    {!searchFields.accountFields[0].accountName ?
                                                        <input data-testid="test-input-Search-account" value={inputVal} onFocus={() => isShowSuggestions(true)} onChange={e => handleChange(e)} className="w-full shadow appearance-none pl-7 pr-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Search Account"></input>
                                                        :
                                                        <div className="flex flex-row justify-between items-center px-2 w-full ">
                                                            <div className="flex flex-col pl-2 truncate mr-2">
                                                                <span>{searchFields.accountFields[0].accountName}</span>
                                                            </div>
                                                            <div data-testid="test-clear-account" className="cursor-pointer" onClick={() => clearSelectedAccount()}>
                                                                <ClearOutlinedIcon fontSize="small" />
                                                            </div>
                                                        </div>}

                                                    {show && <div data-testid="test-div-suggestion" className="w-auto absolute disable-scrollbars h-3\/4 md:h-300 overflow-y-auto border-b-1 border-base flex flex-col z-tooltip shadow-2 bg-white origin-top-right mt-7 rounded-md shadow-lg">
                                                        {accountSuggestions.map((value, index) => (
                                                            <>
                                                                <div onClick={() => handleClick(value)} role="menuitem" key={index} className="flex flex-col border-b-1 border-base px-4 py-3 cursor-pointer hover:bg-gray-15">
                                                                    <div className="text-2">
                                                                        {highlightText(value.accountName)}
                                                                        {/* {value.accountName} */}
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ))}
                                                    </div>}
                                                </div>
                                                {/* <SimpleInputField propid={value.fieldName} testid={`Min-${value.fieldName}`} onChange={handleChange} type={value.type} placeholder={value.isMinMax ? 'Min' : ''} id={value.label.replace(/\s/g, '')} value={value.minValue} classes={value.isMinMax ? '' : 'w-full'}></SimpleInputField> */}
                                            </div>
                                        </div>

                                    </div>
                                </>
                        )
                    }) : null}
            </div>
        </>
    )
}

export default AccountFilter
